import React from 'react';
import { Button, Popconfirm, message } from 'antd';
import { LogoutOutlined, SettingTwoTone } from '@ant-design/icons';

const LogoutButton = () => {
    const handleLogout = () => {
        localStorage.removeItem('authToken');
        message.success('Logged out successfully');
        window.location.reload();
    };

    return (
        <>
            <Popconfirm
                title="Are you sure you want to logout?"
                onConfirm={handleLogout}
                okText="Yes"
                cancelText="No"
            >
                <Button type="primary" danger icon={<LogoutOutlined />}>
                    Logout
                </Button>
            </Popconfirm>
        </>
    );
};

export default LogoutButton;